module.exports = __webpack_public_path__ + "static/media/ehealth-pro-bg.1c1c7f66.png";